import { useEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import AboutProgramme from './aboutprogramme'
import StatusPointAndTier from './statuspointandtier'
import HowToJoin from './howtojoin'
import { adobePageViewEvent, adobeInteractionEvent } from 'utils/adobewa'

const PriorityProgrammeContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #e6dfd7;
`

const PageTilteText = styled.div`
    color: #121b21;
    text-align: center;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
    padding-top: 32px;
    padding-bottom: 24px;
`

export default function PriorityProgramme() {
    const { t, i18n } = useTranslation('', { keyPrefix: 'priorityprogramme' })
    const lang = i18n.language

    useEffect(() => {
        adobePageViewEvent(lang)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            // Calculate current scroll position and window height
            const scrollY = window.pageYOffset
            const windowHeight = window.innerHeight

            // Calculate document height
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.documentElement.clientHeight
            )

            // Check if the user has scrolled to the bottom (or very close)
            // A small threshold can be added to account for potential rounding issues
            const threshold = 5 // Pixels from the bottom to consider "at bottom"
            if (scrollY + windowHeight >= documentHeight - threshold) {
                adobeInteractionEvent({
                    lang: lang,
                    eventID: `prioritysite_Scroll_Page_Bottom`,
                })

                window.removeEventListener('scroll', handleScroll)
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll)

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <PriorityProgrammeContainer>
            <PageTilteText>{t(`title`)}</PageTilteText>
            <AboutProgramme />
            <StatusPointAndTier />
            <HowToJoin />
        </PriorityProgrammeContainer>
    )
}
